//Default.ts ==============================================================
// https://risingstars.js.org/2018/en/
// https://www.robinwieruch.de/essential-react-libraries-framework/
// https://material-ui.com/style/typography/ - For font style choices.
// http://flexbox.buildwithreact.com/    Flexbox code generator.

import "./Util/Prototypes";

import * as MainMap from "./MainMap";
import * as MainMenu from "./Menus/MainMenu";
import * as MainToolbar from "./Menus/MainToolbar";
import * as QueryString from "./QueryString";
import * as Settings from "./Settings";
import * as SignIn_Auth0 from "./Util/SignIn_Auth0";
import * as Util from "./Util/Util";
import * as Util_App from "./Util/Util_App";

import { createTheme } from "@mui/material/styles";
import { Theme } from "@mui/material/styles/createTheme";

import Axios, { AxiosResponse } from "axios";

import * as projection from "@arcgis/core/geometry/projection";

import "./app.css"; //Load the application css file.

export let clientIP: string = "";
export let theme: Theme = null;
export let styles: iStyles;

let ii: number; //Index into the feature services array.
let featureServiceURLs: string[];

export interface iAjaxData {
   action: string;        //Function to call in web api.
   clientIP?: string;     //Client IP address.
   email?: string;        //email.
   userName?: string;     //Username.
   accessLevel?: number;  //Access level.
   pinList?: string[];
}

//Register service worker for progressive web application (PWA).
window.addEventListener("load", () => {
   if ("serviceWorker" in navigator) {
      navigator.serviceWorker.register("service-worker.js").then(registration => {
         Util.logMsg("Service Worker registered with scope: " + registration.scope);

      }).catch((error: Error) => {
         Util.errMsg("Service Worker registration failed.", error);
      });
   }
});

//window.onload = function (): void {
   getClientIpAddress();
//};

//Get client public IP address.
function getClientIpAddress() {
   Util.logMsg("Top of getClientIpAddress");

   if (Settings.getClientIpAddress) {
      Util.logMsg("Getting client IP address. Host name: " + location.hostname);

      if (location.hostname === "localhost") {
         clientIP = "127.0.0.1";
         Util.logMsg("Client IP: " + clientIP);
         initWebsite();

      } else {
         //Axios.get("https://api.ipify.org")
         Axios.get("https://myexternalip.com/raw")
            .then(function (response) {
               clientIP = response.data as string;
               Util.logMsg("ipify client IP: " + clientIP);
               initWebsite();
            })
            .catch(function (error: Error) {
               Util.errMsg("api.ipify.org error getting IP Address", error);
               initWebsite();
            });
      }

   } else {
      initWebsite();
   }
}

//Initialize website.
function initWebsite(): void {
   Util.logMsg('Initializing website.');

   setMuiTheme();        // Create MUI theme.
   QueryString.getAll(); // Get all query strings.

   if (Settings.signInEnabled && SignIn_Auth0) {
      SignIn_Auth0.authenticate({ success: function () { getSettings(); }, fail: function () { getSettings(); } });
   } else {
      getSettings();
   }
}

//Get xml file settings.
export function getSettings(): void {
   Util.logMsg('Getting settings from server.');
   const ajaxData: iAjaxData = { action: "getSettings", clientIP: clientIP, email: SignIn_Auth0.email, userName: SignIn_Auth0.userName, accessLevel: SignIn_Auth0.accessLevel };

   //To use webapi project when debugging, both Visual Studio projects must be started at the same time and
   // a virtual application must be created for the webapi project. See the solution and webapi project properties.
   let webAPI_path: string = Settings.webAPI_url;
   if (location.hostname === "localhost") {
      webAPI_path = Settings.webAPI_local_url;
   }
   Util.logMsg("webAPI_path: " + webAPI_path);

   Axios.post(webAPI_path, ajaxData)
      .then(function (response: AxiosResponse<any, any>) {
         if (!response) {
            Util.errMsg("ajax results from server are null");
            return;
         }
         if (response.data.errMsg !== "") {
            Util.errMsg(response.data.errMsg);
         }

         Util.logMsg("Settings", response.data);

         Settings.setClientSettings(response.data);
         Util.logMsg("Access Level: " + Settings.security.accessLevel);
         document.title = Settings.websiteTitle;
         initFeatureServiceLayerIDs(); //Get feature service id's;
      })
      .catch(function (error: Error) {
         Util.errMsg("ajax error getting settings", error);
      });
}

//Get feature service layer id's.
function initFeatureServiceLayerIDs() {
   featureServiceURLs = [];

   for (const operMap of Settings.operMaps) {
      let url: string = operMap.mapServiceURL;
      const pos1: number = url.indexOf("/FeatureServer");
      const pos2: number = url.indexOf("FeatureServer/");

      if (pos1 !== -1 && pos2 === -1) {
         url = url.SubStr(0, pos1);
         if (!featureServiceURLs.Contains(url)) {
            featureServiceURLs.Add(url);
         }
      }
   }

   ii = -1;
   getFeatureServiceLayerIDs();
}
//Get feature service layer id's and geometry types.
function getFeatureServiceLayerIDs() {
   ii++; //Process next feature service.

   if (ii < featureServiceURLs.length) {
      let url: string = featureServiceURLs[ii] + "/FeatureServer?f=pjson";

      //Add proxy if needed for feature service.
      if (Settings.proxyMapServiceURLs.Contains(featureServiceURLs[ii] + "/FeatureServer")) {
         url = Settings.proxyUrl + "?" + url;
      }

      // Needs work probably on server not here.
      //const config: AxiosRequestConfig = {
      //   withCredentials: true,
      //   headers: {
      //      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      //      'Accept': 'application/json'
      //   }
      //};

      Axios.get(url) // ,config
         .then(function (response: AxiosResponse<any, any>) {

            if (response.data.error) {
               Util.errMsg("Axios get Response error getting feature service id's: " + url, response.data.error);

            } else {
               const layers = response.data.layers as any[];

               for (const layer of layers) {
                  const layerName = layer.name as string;

                  if (layerName.StartsWith(" ") || layerName.EndsWith(" ")) {
                     Util.errMsg("Layer name begins or ends with a blank: ->" + layerName + "<-");
                  }

                  for (const operMap of Settings.operMaps) {
                     if (operMap.serviceType === "FeatureLayer") {
                        if (layerName === operMap.thumbnail && url.Contains(operMap.mapServiceName)) {
                           const layerID = layer.id as string;

                           operMap.mapServiceURL += "/" + layerID;
                           const laySpec: Settings.iLayer = Util_App.getLayerSpec(layerName);
                           if (laySpec) {
                              laySpec.mapServiceURL = operMap.mapServiceURL;
                              laySpec.geometryType = layer.geometryType.replace("esriGeometry", "").toLowerCase() as string;

                              //   if (layerName === "Road Names") {
                              //      let junk = 1;
                              //   }
                           }
                        }
                     }
                  }
               }
            }

            getFeatureServiceLayerIDs();
         })
         .catch(function (error: Error) {
            Util.errMsg("Axios get Catch error getting feature service id's: " + url, error);
            getFeatureServiceLayerIDs();
         });

   } else { //All feature services have been processed.
      buildWebsite();
   }
}
//Build website.
function buildWebsite(): void {
   Util.logMsg('Building esri map.');

   const phoneWidths: number[] = [360, 375, 411, 412, 414, 390, 428];
   if (phoneWidths.Contains(window.screen.width)) {
      Settings.setIsPhone(true);
      Settings.setLeftPanelWidth(window.screen.width);
   }

   //Settings.isPhone = true; //Phone testing.

   //Global styles.
   styles = {
      appWidgetDiv: { position: 'absolute', top: 0, left: 0, zIndex: 3, minWidth: Settings.leftPanelWidth, overflow: 'auto' },
      appToolHeading: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: Settings.headingColor, borderTopLeftRadius: Settings.borderRadius, borderTopRightRadius: Settings.borderRadius },
      appToolDiv: { maxWidth: Settings.leftPanelWidth, padding: 5, overflow: 'auto' },
   };

   //Build website.
   Util.logMsg('Building main menu react components.');

   MainMap.build();
   MainMenu.render();
   MainToolbar.render();

   //Load client side projection dependencies.
   void projection.load();

   //Hide startup spinner.
   //const splashImg = document.getElementById("splash_img");
   //splashImg.style.display = "none";

   const startupSpinner = document.getElementById("startup_spinner");
   startupSpinner.style.display = "none";
}

export interface iStyles {
   aliasCell?: React.CSSProperties;
   appToolDiv?: React.CSSProperties;
   appToolHeading?: React.CSSProperties;
   appWidgetDiv?: React.CSSProperties;
   backColor?: React.CSSProperties;
   bookmarks?: React.CSSProperties;
   body?: React.CSSProperties;
   bodyCell?: React.CSSProperties;
   bodyCellLabel?: React.CSSProperties;
   bodyCellValue?: React.CSSProperties;
   button?: React.CSSProperties;
   c1?: React.CSSProperties;
   c2?: React.CSSProperties;
   clearButton?: React.CSSProperties;
   col1Container?: React.CSSProperties;
   compCell?: React.CSSProperties;
   criteriaTable?: React.CSSProperties;
   dataCell?: React.CSSProperties;
   default?: React.CSSProperties;
   disclaimer?: React.CSSProperties;
   div?: React.CSSProperties;
   dummy?: React.CSSProperties;
   errMsg?: React.CSSProperties;
   expansionPanelDetails?: React.CSSProperties;
   expansionPanelMain?: React.CSSProperties;
   expansionPanelSummary?: React.CSSProperties;
   fab?: React.CSSProperties;
   formControlLabel?: React.CSSProperties;
   gallery?: React.CSSProperties;
   gallery_choose?: React.CSSProperties;
   gallery_mapview?: React.CSSProperties;
   geocoder?: React.CSSProperties;
   heading?: React.CSSProperties;
   help?: React.CSSProperties;
   header?: React.CSSProperties;
   headingCell?: React.CSSProperties;
   hyperlink?: React.CSSProperties;
   input?: React.CSSProperties;
   layName?: React.CSSProperties;
   layersDropdown?: React.CSSProperties;
   layersDropdownLabel?: React.CSSProperties;
   legend?: React.CSSProperties;
   logo?: React.CSSProperties;
   mapLayers?: React.CSSProperties;
   paper?: React.CSSProperties;
   paperBeige?: React.CSSProperties;
   paperYellow?: React.CSSProperties;
   paperYellow2?: React.CSSProperties;
   parcels?: React.CSSProperties;
   pin?: React.CSSProperties;
   popoverContent?: React.CSSProperties;
   printScale?: React.CSSProperties;
   printStyle?: React.CSSProperties;
   resultsDiv?: React.CSSProperties;
   row1Container?: React.CSSProperties;
   rowStyle1?: React.CSSProperties;
   rowStyle2?: React.CSSProperties;
   rowStyle3?: React.CSSProperties;
   seal?: React.CSSProperties;
   slider?: React.CSSProperties;
   subject?: React.CSSProperties;
   subjectCell?: React.CSSProperties;
   table?: React.CSSProperties;
   table1?: React.CSSProperties;
   table2?: React.CSSProperties;
   tableCell?: React.CSSProperties;
   textBox?: React.CSSProperties;
   title?: React.CSSProperties;
   titleCell?: React.CSSProperties;
   toolDiv?: React.CSSProperties;
   toolStyle?: React.CSSProperties;
   widgetDiv?: React.CSSProperties;
   zoomTo?: React.CSSProperties;
   zoomToNo?: React.CSSProperties;
}

function setMuiTheme(): void {
   //Get mui theme.
   theme = createTheme({
      breakpoints: { values: { xs: 0, sm: Settings.breakpoint_sm, md: Settings.breakpoint_md, lg: 1280, xl: 1920 } },
      palette: {
         primary: { main: Settings.primaryColor },
         secondary: Settings.secondaryColor,

         mode: Settings.colorType,
         action: {
            active: Settings.activeColor.toLowerCase(),
            hover: Settings.hoverColor.toLowerCase(),
            selected: Settings.selectedColor.toLowerCase(), //Not supported in MUI V5.
            selectedOpacity: 0.3,
         },
         background: {
            default: Settings.backgroundColor.toLowerCase(),
            paper: Settings.paperColor.toLowerCase(),
         },
         text: {
            primary: Settings.textColorPrimary.toLowerCase(),
            secondary: Settings.textColorSecondary.toLowerCase(),
         },
         info: { main: Settings.textColorPrimary }, //Button text color hack.
      },
      shape: { borderRadius: Settings.borderRadius },

      components: {
         MuiOutlinedInput: {
            styleOverrides: {
               root: {
                  height: 48,
               },
            },
         },
         MuiTabs: {
            styleOverrides: {
               indicator: {
                  backgroundColor: Settings.tabIndicatorColor,
               },
            },
         },
         MuiTab: {
            styleOverrides: {
               root: {
                  textTransform: "none",
                  "&:hover": {
                     backgroundColor: Settings.tabHoverColor,
                     borderRadius: 5,
                  },
                  "&$selected": {
                     backgroundColor: Settings.tabActiveColor,
                     borderRadius: 5,
                     "&:hover": {
                        backgroundColor: Settings.tabHoverColor,
                        borderRadius: 5,
                     },
                  },
               },
            },
         },
         MuiButton: {
            styleOverrides: {
               root: {
                  textTransform: "none",
                  "&:hover": {
                     boxShadow: "0 0 20px 3px white",
                  },
               },
            },
         },
         MuiFormControlLabel: {
            styleOverrides: {
               root: {
                  "&:hover": {
                     //backgroundColor: '#FFE57F',
                     boxShadow: "0 0 20px 3px " + Settings.formControlHoverColor,
                     borderRadius: 4,
                  },
               },
            },
         },
         MuiAccordionSummary: {
            styleOverrides: {
               root: {
                  "&:hover": {
                     backgroundColor: Settings.tabHoverColor,
                  },
               },
            },
         },
         MuiTooltip: {
            styleOverrides: {
               tooltip: {
                  maxWidth: 500,
               },
            },
         },
      },

   });
   Util.logMsg("Created MUI theme. Primary color: " + theme.palette.primary.main);
}
